<template>
    <section id="all-emr-orders-view" class="all-cases-view">
      <div class="navbarComponent">
        <div class="container-default">
          <div class="listings-navbar">
            <el-row>
              <el-col :lg="7">
                <ul class="d-flex list-items-group-15 barcode-print">
                  <li>
                    <div class="form-element input-with-icon search-input-lg">
                      <el-input
                        placeholder="Accession / Patient Name"
                        v-model="search_string"
                        @input="getAutoCompleteOrders()"
                        :clearable="true"
                        suffix-icon="el-icon-date"
                      ></el-input>
                      <span>
                        <img
                          src="@/assets/images/icons/search-icon-with-bg-red.svg"
                          alt="icon"
                          class="img-fluid icon"
                        />
                      </span>
                    </div>
                  </li>
                </ul>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div class="container-default" style="padding-top: 0">
        <div class="primary-content-view" v-loading="loading">
          <div
            class="listings listings__table listings__all-cases"
            id="all-cases-listings"
          >
            <el-table
              :data="getEMRWithIssuesData.data"
              height="calc(100vh - 200px)"
              :default-sort="{
                prop: orderBy,
                order: orderType == 'asc' ? 'ascending' : 'descending',
              }"
              @sort-change="onChangeSort"
            >
            <el-table-column label="EMR #" min-width="150" fixed="left">
              <template #default="scope">
                <div class="emr-id" v-if="scope.row.patient_info">
                  <span @click="goToViewOrders(scope.row._id)" class="cursor">
                    {{
                      scope.row.patient_info.emr
                        ? scope.row.patient_info.emr
                        : "--"
                    }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Case Type"
              min-width="135px"
              prop="case_types"
              sortable="custom"
              fixed="left"
            >
              <template #default="scope">
                <div
                  class="case-type"
                  v-if="scope.row.case_types && scope.row.case_types.length > 1"
                >
                  <el-dropdown>
                    <span class="case-data-type">
                      {{ getCaseTypes(scope.row.case_types)[0] }}

                      <img
                        src="@/assets/images/case-type-arrow.svg"
                        alt="icon"
                      />
                    </span>

                    <template #dropdown>
                      <el-dropdown-menu class="case-type-dropdown">
                        <el-dropdown-item
                          class="cases-view"
                          v-for="(caseType, index) of getCaseTypes(
                            scope.row.case_types
                          )"
                          :key="index"
                        >
                          {{ caseType }}
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div>
                <div
                  v-else-if="
                    scope.row.case_types && scope.row.case_types.length == 1
                  "
                  class="case-type"
                >
                  <span class="case-data-type">
                    {{ getCaseTypes(scope.row.case_types)[0] }}
                  </span>
                </div>
                <div v-else></div>
              </template>
            </el-table-column>            
            <el-table-column
              prop="patient_info.first_name"
              label="PATIENT NAME"
              min-width="150"
              sortable="custom"
              fixed="left"
            >
              <template #default="scope">
                <el-button
                  placement="top"
                  class="title-on-hover"
                  :title="convertToUppercase(getPatientNameByInfo(scope.row.patient_info))"
                  @click="
                    copyTitle(getPatientNameByInfo(scope.row.patient_info))
                  "
                >
                  <span class="text-center ordering_facility-value">{{
                    convertToUppercase(getPatientNameByInfo(scope.row.patient_info))
                  }}</span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="Patient DOB" min-width="130">
              <template #default="scope">
<div style="cursor: default;">
                {{ formatDate(scope.row.patient_info.date_of_birth) }}
</div>
              </template>
            </el-table-column>
            
            <el-table-column
              label="CREATED ON"
              min-width="130"
              prop="created_at"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.created_at" class="d-flex">
                  <div style="cursor: default;" class="date pr-10">
                    {{ momentWithTimezone(scope.row.created_at, "MM-DD-yyyy") }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="ORDER PLACED ON"
              min-width="150"
              prop="order_placed_at"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.order_placed_at" class="d-flex">
                  <div style="cursor: default;" class="date pr-10">
                    {{ momentWithTimezone(scope.row.order_placed_at, "MM-DD-yyyy") }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="hospital"
              label="ORDERING FACILITIES"
              min-width="200"
            >
              <template #default="scope">
                <el-button
                  placement="top"
                  class="title-on-hover"
                  :title="scope.row.hospital ? scope.row.hospital.name : '--'"
                >
                  <span class="ordering_facility-value">{{
                    scope.row.hospital ? scope.row.hospital.name : "--"
                  }}</span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="PHYSICIAN" min-width="150">
              <template #default="scope">
                <el-button
                  placement="top"
                  class="title-on-hover"
                  :title="
                    scope.row.ordering_physician
                      ? scope.row.ordering_physician.name.includes('Dr')
                        ? scope.row.ordering_physician.name
                        : 'Dr ' + scope.row.ordering_physician.name
                      : '--'
                  "
                >
                  <span class="ordering_physician-value">
                    {{
                      scope.row.ordering_physician
                        ? scope.row.ordering_physician.name.includes("Dr")
                          ? scope.row.ordering_physician.name
                          : "Dr " + scope.row.ordering_physician.name
                        : "--"
                    }}
                  </span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="Status"
              width="130"
              prop="status"
              sortable="custom"
            >
              <template #default="scope">
                <div class="column-status" v-if="scope.row.status">
                  <span
                    class="el-dropdown-link"
                    v-if="scope.row.status == 'COMPLETED'"
                  >
                    <el-tag :type="getStatusType(scope.row.status)"
                      >FINALIZED</el-tag
                    >
                  </span>
                  <span
                    class="el-dropdown-link"
                    v-else-if="scope.row.status == 'CANCELLED'"
                  >
                    <el-tag :type="getStatusType(scope.row.status)"
                      >REJECTED</el-tag
                    >
                  </span>
                  <span
                    class="el-dropdown-link"
                    v-else-if="scope.row.status == 'ACTIVE'"
                  >
                    <el-tag :type="getStatusType(scope.row.status)"
                      >OPEN</el-tag
                    >
                  </span>

                  <span class="el-dropdown-link" v-else>
                    <el-tag :type="getStatusType(scope.row.status)">{{
                      scope.row.status
                    }}</el-tag>
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="action"
              label="Actions"
              :width="90"
              fixed="right"
            >
              <template #default="scope">
                <ul class="listings__action-buttons">
                  <li @click="goToEMRView(scope.row._id)">
                    <el-button class="view-button" title="View Case">
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/view-icon.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/view-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li>
                    <el-button
                      @click="resolve(scope.row)"
                      class="approval-button"
                      title="Resolve"
                    >
                      <img
                        src="@/assets/images/icons/actions/convert-to-case-inactive.svg"
                        alt="icon"
                        class="action-inactive"
                      />
                      <img
                        src="@/assets/images/icons/actions/convert-to-case-active.svg"
                        class="action-active"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                </ul>
              </template>
            </el-table-column>                      
            </el-table>
          </div>
          <div class="listings listings__pagination">
            <el-pagination
              v-model:currentPage="page"
              v-model:page-size="pageSize"
              :page-sizes="[25, 50, 75, 100]"
              layout=" prev, pager, next, jumper, sizes, total"
              :total="getEMRWithIssuesData.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import FilterHelper from "@/mixins/FilterHelper";
  import caseDataHelper from "@/mixins/caseDataHelper";
  import caseConstants from "@/config/constants/caseConstants";
  import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
  export default {
    name: "EMRWithIssues",
    data() {
      return {
        caseTypeMap: caseConstants.CASE_TYPE_MAP,
        loading:false,
        search_string:""
      }
    },
    mixins:[FilterHelper,caseDataHelper],
    computed:{
      ...mapGetters("emrOrders",["getEMRWithIssuesData","getResolveEMRWithIssues"]),
      getCaseTypes() {
        return (caseTypes) => {
          return (caseTypes || []).map((e) => this.caseTypeMap[e]);
        };
      },
      ...mapGetters("errors", ["getErrors", "getError"]),
      getStatusType() {
        return (statusVal) => {
          const status = statusVal.trim();
          if (status == "ACTIVE") {
            return "";
          } else if (status == "COMPLETE") {
            return "success";
          } else if (status == "TEST_REPORTS") {
            return "warning";
          } else if (status == "ARCHIVED") {
            return "danger";
          } else if (status == "REJECTED") {
            return "darkDanger";
          } else if (status == "PENDING") {
            return "danger";
          } else {
            return "";
          }
        };
      },
    },
    async mounted() {
      this.setQueryParamsData();
      await this.fetchEmrOrders();
    },
    methods: {
      async resolve(emr){
        try {
          let params = {
            emr_id:emr._id
          }
          await this.$store.dispatch("emrOrders/resolveEMRWithIssuesById",params)
          if(this.getResolveEMRWithIssues){
            successNotification("EMR resolved successfully")
            await this.fetchEmrOrders();
          } else {
            errorNotification(this.getError || "Error while resolved EMR")
          }
        } catch(err){
          console.log('err: ', err);
        }
      },
      goToEMRView(emr) {
        this.$router.push({
          name: "EMRWithIssuesView",
          params: { order_id: emr },
          query: {
            ...this.$route.query,
            redirectRoute: this.$route.name
          },
        });
      },
      clearSearchBy() {
        if (this.$route.query.selectedEmrSearchBy == "send_to_phlebio") {
          this.fetchEmrOrders(1);
        }
      },
      onChangeSort({ order, prop }) {
        if (order && prop) {
          this.orderBy = prop;
          this.orderType = order == "ascending" ? "asc" : "desc";
        } else {
          this.orderBy = "";
          this.orderType = "";
        }
        this.fetchEmrOrders();
      },
      setQueryParamsData() {
        this.page = this.$route.query.selectedEmrPage
          ? parseInt(this.$route.query.selectedEmrPage)
          : 1;
  
        if (this.$route.query.search_string) {
          this.search_string = this.$route.query.search_string;
        }        
        this.search_string = this.$route.query.selectedEmrString;
  
        this.pageSize = this.$route.query.selectedEmrPageSize
          ? parseInt(this.$route.query.selectedEmrPageSize)
          : 25;
  
        if (this.$route.query.selectedEmrOrderBy) {
          this.orderBy = this.$route.query.selectedEmrOrderBy;
        }
        if (this.$route.query.selectedEmrOrderType) {
          this.orderType = this.$route.query.selectedEmrOrderType;
        }
      },
      prepareParams() {
        const params = {
          page: this.page,
          limit: this.pageSize,
        };
        if(this.search_string){
          params.search_string = this.search_string
        }
        return params;
      },
      getAutoCompleteOrders() {
        setTimeout(() => {
          this.page = 1;
          this.fetchEmrOrders();
        }, 600);
      },
      handleSizeChange(size) {
        this.pageSize = size;
        this.page = 1;
  
        this.fetchEmrOrders();
      },
      handleCurrentChange(page) {
        this.page = page;
  
        this.fetchEmrOrders();
      },
      async fetchEmrOrders() {
        try {
          this.loading = true;
          let params = this.prepareParams();
          await this.$store.dispatch("emrOrders/fetchEMRWithIssues", params);
          this.updateQueryParams(params);
          this.loading = false;
        } catch (error) {
          console.log(error);
        } finally {
            this.loading = false
        }
      },
      updateQueryParams(params) {
        let selectedParams = {
          selectedEmrPage: params.page,
          selectedEmrString: params.search_string,
          selectedEmrPageSize: params.limit,
          selectedEmrOrderBy: params.order_by,
          selectedEmrOrderType: params.order_type,
          selectedEmrSearchBy: this.searchBy || undefined,
        };
        this.updateQueryParam(this.$route.name, selectedParams);
      },
      goToViewOrders(orderId) {
        this.$router.push({
          name: "View-Case-Information",
          params: { order_id: orderId },
          query: { ...this.$route.query, redirectRoute: this.$route.name },
        });
      },
    },
  };
  </script>
  
  <style lang="scss">
  .image-fluid {
    width: 100%;
  }
  #all-emr-orders-view {
    .stickyNavbar {
      padding-bottom: 5px !important;
      .container-default {
        padding-top: 0;
      }
    }
  }
  .validation-button {
    display: block;
    margin-bottom: -5px;
    img {
      width: 25px;
    }
  }
  .phlebio-inputs {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 20px;
    row-gap: 10px;
    padding-top: 0.5rem;
    .el-input__inner {
      margin-top: 5px;
      background: #ffffff;
      border: 0.719521px solid #56ccf2;
      box-sizing: border-box;
      border-radius: 2px;
      height: 35px;
    }
    .name {
      height: 30px;
      color: #000000;
    }
  }
  .phlebio-radio {
    .el-radio-group {
      display: flex;
      .el-radio__input .el-radio__inner {
        border-color: transparent;
        box-shadow: 0 0 0 1px #ced1d6;
      }
      .el-radio__input.is-checked .el-radio__inner {
        background-color: #0a5da6;
        border-color: #ffffff;
      }
      .el-radio__input.is-checked + .el-radio__label {
        color: #0a5da6;
      }
    }
  }
  </style>
  